<template>
  <div id="pageSansMenu" class="d-flex flex-column main-sans-menu">
    <vue-headful
      :title="metaData.title"
      :description="metaData.description"
      :keywords="metaData.keywords"
      :image="metaData.metaOGImage"
      :url="metaUrl"
      :head="{
        'meta[name=robots]': { content: metaData.metaNoIndex },
        'link[hreflang=en-ca]': { href: pathAnglais },
        'link[hreflang=fr-ca]': { href: pathFrancais },
        'link[rel=apple-touch-icon]': { type: 'image/png' },
        'link[rel=icon]': { type: 'image/png' },
      }"
    />

    <div class="w-100 h-100">
      <main class="d-flex align-items-center h-100 px-0 overflow-hidden">
        <EditableArea v-if="content.main" class="w-100 h-100" :content="content.main" />
      </main>
    </div>
  </div>
</template>

<script>
import vueHeadful from 'vue-headful';
import { EditableArea } from '@/vue-editor';

import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

import { inMgnl } from '@/helpers/AppHelpers';

import { stripAllHtmlTag } from '@/helpers/StringHelpers';

export default {
  name: 'Bingo',
  components: {
    EditableArea,
    vueHeadful,
  },
  mixins: [mixinEnvironnement],
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {
      metaUrl: document.URL,
      metaData: {
        title: '',
        description: '',
        keywords: '',
        metaNoIndex: '',
        metaOGImage: '',
      },
      pathFrancais: '',
      pathAnglais: '',
    };
  },
  mounted() {
    // TODO: Revoir le chargement du css pour ne pas qu'il soit constament ré-exécuté (à essayer dans le created mais idéalement revoir le chargement à la source)
    // Empêcher le logo Loto-Québec de la barre portail de s'afficher momentanément pleine grandeur
    if (!inMgnl) {
      const style = document.createElement('link');
      style.rel = 'stylesheet';
      style.type = 'text/css';
      style.href = '/mel/.resources/lq-entete-commun/webresources/css/barreportail-app.css?v=210';
      document.head.append(style);
    }

    document.body.scrollTop = 0; // forcer la page à charger en haut de page pour régler un problème sur mobile

    const uri = this.$store.getters['routes/getPathAutreLangue'](window.location.pathname.slice(3));
    this.miseAJourMetaLien(uri);
    this.miseAjourMetaInfo(this.content);

    // Lors du premier click dans le vide (body) la page remonte automatiquement au top, ceci est une patch pour conserver le scroll au bon endroit
    document.body.addEventListener('click', this.fixFirstClickScrollTop);

    document.getElementsByTagName('body')[0].style.backgroundColor = '#121212';
  },
  methods: {
    miseAJourMetaLien(url) {
      this.pathFrancais = this.metaUrl.includes('/fr/')
        ? this.metaUrl
        : window.location.origin + url;
      this.pathAnglais = this.metaUrl.includes('/en/')
        ? this.metaUrl
        : window.location.origin + url;
    },
    miseAjourMetaInfo(info) {
      this.metaData.title = `${info.title ? info.title : ''} | Loto-Québec`;
      this.metaData.description = info.description ? stripAllHtmlTag(info.description) : '';
      this.metaData.keywords = info.keywords ? info.keywords : '';
      this.metaData.metaNoIndex = info.noindex == 'true' ? 'noindex' : 'index, follow';
      this.metaData.metaOGImage = info.metaOGImage ? this.jel_getFichierSrc(info.metaOGImage) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}

.main-sans-menu {
  @include media-breakpoint-down(md) {
    margin-bottom: 32px;
  }
}

main {
  width: inherit;
}
</style>
